import React from "react";
import { CheckIcon } from "lucide-react";
import { images } from "../../data/content";
import { OfferBlock } from "../OfferBlock";
const perks = ["Instant digital access", "Lifetime access", "One-time payment", "7-day guarantee"];
export function FinalCta() {
  return <section className="bg-navy-deep px-5 py-16 md:py-24" data-id="element-155" data-mp="1so2saj0c2iaz">
      <div className="mx-auto max-w-2xl text-center" data-id="element-156" data-mp="1smi0301hrbga">
        <p className="text-sm font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-157" data-mp="1ens27i6ul7qv">Ready to stop reviewing cases randomly…</p>
        <h2 className="mt-3 font-serif text-[32px] font-black leading-[1.1] text-white md:text-5xl" data-id="element-158" data-mp="1iqy7onm4yuwa">
          …and start analyzing them <em className="italic text-gold" data-id="element-159" data-mp="14ryjfh2jci0n">with a system?</em>
        </h2>
        <div className="mt-6 space-y-1 text-[17px] leading-relaxed text-white/80" data-id="element-160" data-mp="19pzy7psxhv6b">
          <p data-id="element-161" data-mp="2z3v9b5lbxftl">You don't need another 20-hour lecture.</p>
          <p className="font-bold text-white" data-id="element-162" data-mp="2z2bwjoyvtmwk">You need a case. A framework. A few focused questions.</p>
          <p data-id="element-163" data-mp="294wg09hw5pj">And a reason to sit down and think.</p>
        </div>

        <img src={images.mockup} alt="The Abdominoplasty Master System bundle" className="-mx-2 mt-8 w-[calc(100%+1rem)] max-w-none md:mx-auto md:w-full" data-id="element-164" data-mp="27k1wan6kmro" />

        <p className="mt-6 font-serif text-xl font-black text-white" data-id="element-165" data-mp="b0x2zzveeuou">The Abdominoplasty Master System™</p>
        <p className="text-white/70" data-id="element-166" data-mp="70mxspffk8b1">6 Premium Volumes + 5 Professional Bonuses</p>
        <p className="mt-3 font-serif text-7xl font-black leading-none text-gold" data-id="element-167" data-mp="3fgg3sac4y1du">$27</p>

        <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-168" data-mp="3ahlkl7a9aat7">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5 text-sm font-semibold text-white" data-id="element-169" data-mp="3oh4fuzhyxro3">
              <CheckIcon className="h-4 w-4 text-cta" aria-hidden="true" data-id="element-170" data-mp="3jggscnsy7sym" />
              {p}
            </li>)}
        </ul>

        <div className="mt-8" data-id="element-171" data-mp="13s6wzyery5m7">
          <OfferBlock dark label="Get the Abdominoplasty Master System™" sub="One-time payment of $27 · Instant digital access · 7-day guarantee" data-id="element-172" data-mp="yriyyss4ooih" />
        </div>
      </div>
    </section>;
}